import React from 'react';
import PropTypes from 'prop-types';
import './linear-progress-bar.scss';

function LinearProgressBar({ completedPercentage }) {
    const progressBarTranslateValue = -(100 - completedPercentage);
    return (
        <div className='linear-progress-root linear-progress-colorSecondary linear-progress linear-progress-determinate'
            role='progressbar'
            aria-valuenow={completedPercentage}>
            <p>{`${completedPercentage}%`}</p>
            <div className='linear-progress-bar linear-progress-bar-color-secondary linear-progress-bar1-determinate'
                style={{ transform: `translateX(${progressBarTranslateValue}%)` }}>
            </div>
        </div>
    );
}

LinearProgressBar.propTypes = {
    completedPercentage: PropTypes.number.isRequired
};

export default LinearProgressBar;
